import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App.tsx";
import "./index.css";

Sentry.init({
  dsn: "https://82a3407f004eefbc71818413ea1e794c@o4510120556036096.ingest.us.sentry.io/4510120610496512",
  sendDefaultPii: true,
  enableTracing: true,
  tracesSampleRate: 1.0,
  enableLogs: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
  ],
});

const container = document.getElementById("root");

if (container) {
  const root = createRoot(container);
  root.render(
    <Sentry.ErrorBoundary fallback={<p>Something went wrong. Please refresh.</p>}>
      <Sentry.Profiler id="story-gauge-app">
        <App />
      </Sentry.Profiler>
    </Sentry.ErrorBoundary>
  );
}
